export default __webpack_public_path__ + "static/media/stats.cc691b31.png";